import { generateBreadcrumbs } from '@bv/utils/route/breadcrumbs/generate-breadcrumbs';
import { computed } from 'vue';

import { userDetailsStore } from '@/stores/auth/user-details.store';
import { useQueuesDataStore } from '@/stores/reports/home.store';
// TODO: Deprecated: Old Call Evaluation under reports (to be deleted)
// import { useUserStore } from '@bv/stores'
// import campaignUpgradeImage from '@/assets/images/routes/campaign/upgrade-campaign.png'

const reportsBreadcrumbs = generateBreadcrumbs({
  label: 'reports.reports',
  route: { name: 'reports' },
});

async function loadFilter(to, from, next) {
  useQueuesDataStore().loadPayload();
  await useQueuesDataStore().getQueuesData();
  next();
}

const hasFilter = computed(() => !!Object.keys(useQueuesDataStore().payload).length);

// TODO: Deprecated: Old Call Evaluation under reports (to be deleted)
// const canAccessCallEvaluation = computed(() => {
//   const store = useUserStore()
//   return !!store.callCenterSettings?.is_call_evaluation_enabled
// })
//
// const showCallEvaluationTab = computed(() => {
//   const store = useUserStore()
//   return !!store.callCenterSettings?.is_call_evaluation_enabled || store.isOwner
// })

const reports_routes = {
  path: '/reports',
  name: 'reports',
  meta: {
    header: { title: 'reports.reports', icon: 'bvi-chart-line' },
    sidebar: [
      { title: 'reports.nav.home', route: '/reports/home', icon: 'bvi-home' },
      {
        title: 'reports.nav.distribution',
        route: '/reports/distribution',
        icon: 'bvi-network',
        permissions: 'read-distribution',
        visible: hasFilter,
      },
      {
        title: 'reports.nav.answered',
        route: '/reports/answered',
        icon: 'bvi-call-received',
        permissions: 'read-answered',
        visible: hasFilter,
      },
      {
        title: 'reports.nav.unanswered',
        route: '/reports/un_answered',
        icon: 'bvi-call-remove',
        permissions: 'read-un-answered',
        visible: hasFilter,
      },
      {
        title: 'reports.nav.agents',
        route: '/reports/agents',
        icon: 'bvi-user-group',
        permissions: 'read-agents',
        visible: hasFilter,
      },
      {
        title: 'reports.nav.outbound',
        route: '/reports/outbound',
        icon: 'bvi-call-outbound',
        permissions: 'read-outbound',
      },
      {
        title: 'reports.nav.search',
        route: '/reports/search',
        icon: 'bvi-search',
        permissions: 'read-search',
      },
      // TODO: Deprecated: Old Call Evaluation under reports (to be deleted)
      // {
      //   title: 'reports.nav.call_evaluation',
      //   route: '/reports/call-evaluations',
      //   icon: 'bvi-face-happy',
      //   permissions: 'read-evaluations',
      //   visible: showCallEvaluationTab
      // },
      {
        title: 'settings.nav.voicemail',
        route: '/reports/voicemail',
        icon: 'bvi-message-unread',
        permissions: 'read-general-voicemail',
        visible: computed(() => userDetailsStore().userWorkspaceServiceDetails.settings?.is_voicemail_enabled),
      },
    ],
  },
  beforeEnter: loadFilter,
  children: [
    {
      path: 'home',
      name: 'reports-home',
      component: () => import('@/components/Reports/ReportsHome.vue'),
      meta: {
        breadcrumbs: reportsBreadcrumbs({
          label: 'reports.nav.home',
          route: { name: 'reports-home' },
        }),
      },
    },
    {
      path: 'distribution',
      name: 'distribution',
      component: () => import('@/components/Reports/distribution/DistributionReport.vue'),
      meta: {
        permissions: 'read-distribution',
        breadcrumbs: reportsBreadcrumbs({
          label: 'reports.nav.distribution',
          route: { name: 'distribution' },
        }),
      },
    },
    {
      path: 'answered',
      name: 'answered',
      component: () => import('@/components/Reports/answered/AnsweredReport.vue'),
      meta: {
        permissions: 'read-answered',
        breadcrumbs: reportsBreadcrumbs({
          label: 'reports.nav.answered',
          route: { name: 'answered' },
        }),
      },
    },
    {
      path: 'un_answered',
      name: 'un_answered',
      component: () => import('@/components/Reports/un-answered/UnAnsweredReport.vue'),
      meta: {
        permissions: 'read-un-answered',
        breadcrumbs: reportsBreadcrumbs({
          label: 'reports.nav.unanswered',
          route: { name: 'un_answered' },
        }),
      },
    },
    {
      path: 'agents',
      name: 'agents',
      component: () => import('@/components/Reports/agents/AgentsReport.vue'),
      meta: {
        permissions: 'read-agents',
        breadcrumbs: reportsBreadcrumbs({
          label: 'reports.nav.agents',
          route: { name: 'agents' },
        }),
      },
    },
    {
      path: 'outbound',
      name: 'outbound',
      component: () => import('@/components/Reports/outbound/OutboundReport.vue'),
      meta: {
        permissions: 'read-outbound',
        breadcrumbs: reportsBreadcrumbs({
          label: 'reports.nav.outbound',
          route: { name: 'outbound' },
        }),
      },
    },
    {
      path: 'search',
      name: 'search',
      component: () => import('@/components/Reports/search/SearchReport.vue'),
      meta: {
        permissions: 'read-search',
        breadcrumbs: reportsBreadcrumbs({
          label: 'reports.nav.search',
          route: { name: 'search' },
        }),
      },
    },
    // TODO: Deprecated: Old Call Evaluation under reports (to be deleted)
    // {
    //   path: 'call-evaluations',
    //   name: 'call-evaluations',
    //   component: () => import('@/components/Reports/call-evaluations/CallEvaluations.vue'),
    //   meta: {
    //     permissions: 'read-evaluations',
    //     canAccess: canAccessCallEvaluation,
    //     redirectUnauthorized: { path: '/dashboard' },
    //     upgradeState: {
    //       image: campaignUpgradeImage,
    //       title: 'reports.call_evaluation_upgrade.title',
    //       description: 'reports.call_evaluation_upgrade.subtitle'
    //     },
    //     breadcrumbs: reportsBreadcrumbs({
    //       label: 'reports.nav.call_evaluation',
    //       route: { name: 'call-evaluations' }
    //     })
    //   }
    // },
    {
      path: 'call-ai-analysis',
      name: 'callSummary',
      component: () => import('@/components/Reports/CallSummary.vue'),
      meta: {
        breadcrumbs: reportsBreadcrumbs({
          label: 'reports.nav.ai_analysis',
          route: { name: 'callSummary' },
        }),
      },
      // the requiredPermission will replaced with actual permission name when added from backend side
    },
    // TODO: find way to prevent route enter if does not have the permission
    {
      path: 'voicemail',
      meta: {
        breadcrumbs: reportsBreadcrumbs({
          label: 'settings.nav.voicemail',
          route: { name: 'voicemail-list' },
        }),
      },
      children: [
        {
          path: '',
          name: 'voicemail-list',
          component: () => import('@/components/Settings/Voicemail/List.vue'),
          meta: { permissions: 'read-general-voicemail' },
        },
      ],
    },
    // {
    //   path: 'csat',
    //   name: 'csat',
    //   component: () => import('@/components/Reports/Csat/CsatReport.vue'),
    //   meta: { requiresPermission: true, requiredPermission: 'read-csat' }
    // }
  ],
};

export default reports_routes;
